import React from 'react';
import styles from './CartSummary.module.css';

interface CartSummaryProps {
  itemCount: number;
  subtotal: string;
  margin: string;
  total: string;
}

export const CartSummary: React.FC<CartSummaryProps> = ({
  itemCount,
  subtotal,
  margin,
  total,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span>🛒 Cart Summary</span>
        <span className={styles.badge}>{itemCount}</span>
      </div>
      <div className={styles.row}>
        <span>Items</span>
        <span className={styles.value}>{itemCount} items</span>
      </div>
      <div className={styles.row}>
        <span>Subtotal</span>
        <span className={styles.value}>{subtotal}</span>
      </div>
      <div className={styles.row}>
        <span>Est. Margin</span>
        <span className={styles.green}>{margin}</span>
      </div>
      <div className={styles.totalRow}>
        <span>Total</span>
        <span className={styles.totalValue}>{total}</span>
      </div>
    </div>
  );
};
